import { encodeArrayForQueryString } from '@cks-internal/react-base';

export const FolioEndpoints = {
  overview: {
    counts: '/api/folio/counts'
  },
  folio: {
    overview: (page: number, pageSize: number) => {
      return `api/folio/overview?page=${page}&pageSize=${pageSize}`;
    },
    inbox: (page: number, pageSize: number) => {
      return `api/folio/inbox?page=${page}&pageSize=${pageSize}`;
    },
    checkedOut: (page: number, pageSize: number) => {
      return `api/folio/checked-out?page=${page}&pageSize=${pageSize}`;
    },
    preRec: (page: number, pageSize: number) => {
      return `api/folio/pre-rec?page=${page}&pageSize=${pageSize}`;
    },
    issueRec: (page: number, pageSize: number) => {
      return `api/folio/issue-rec?page=${page}&pageSize=${pageSize}`;
    },
    addComment: 'api/folio/addComment',
    assignUser: {
      get: 'api/folio/assignUser/preview',
      post: 'api/folio/assignUser'
    },
    setStatusDeleted: (activityId: number) => `api/folio/setStatusDeleted/${activityId}`,
    toggleAssigned: (activityId: number) => `api/folio/toggleAssigned/${activityId}`,
    unassign: (activityIds: number[]) => `/api/folio/unassign?${encodeArrayForQueryString('activityIds', activityIds)}`,
    sendToRes: (activityIds: number[]) =>
      `/api/folio/sendToRes?${encodeArrayForQueryString('activityIds', activityIds)}`,
    setComment: (activityId: number) => `api/folio/setComment/${activityId}`,
    update: 'api/folio/update'
  },
  folioInbox: {
    items: '/api/folio-inbox/items',
    statusActivities: (assignedId?: string) => {
      const params = assignedId ? `?assignedId=${assignedId}` : '';
      return `api/folio-inbox/status-activities${params}`;
    },
    checkedOutItems: 'api/folio-inbox/checked-out-items',
    generateTemplate: 'api/folio-inbox/generate-template'
  },
  reconciliation: {
    regenerateMir: (activityId: number) => {
      return `/api/reconciliation/${activityId}/mir/regenerate`;
    },
    getReconciliation: (activityId: number) => {
      return `/api/reconciliation/${activityId}`;
    },
    postReconciliation: (activityId: number) => {
      return `/api/reconciliation/${activityId}`;
    },
    sendInvoice: (activityId: number, invoiceDate: string) => {
      return `/api/reconciliation/${activityId}/invoice?invoiceDate=${invoiceDate}`;
    },
    getIssueRecNotes: (activityId: number) => {
      return `/api/reconciliation/${activityId}/issue-notes`;
    },
    postIssueRecNotes: (activityId: number, note: string) => {
      return `/api/reconciliation/${activityId}/issue-notes?note=${note}`;
    },
    folioPdfs: (activityId: number) => {
      return `/api/reconciliation/${activityId}/folios`;
    },
    process: (activityId: number) => {
      return `/api/reconciliation/${activityId}/process`;
    },
    updateProcessingStatus: (activityId: number) => {
      return `/api/reconciliation/${activityId}/processing-status`;
    }
  },
  folioMerge: {
    get: (activityId: number) => {
      return `/api/folioMerge/${activityId}`;
    },
    post: (activityId: number, destinationActivityIds: number[]) => {
      return `/api/folioMerge/${activityId}?${encodeArrayForQueryString('destinationActivityIds', destinationActivityIds)}`;
    },
    split: (activityId: number, fileHandle: string) => {
      return `/api/folioMerge/${activityId}/split/${fileHandle}`;
    },
    pdfPageCount: (activityId: number, fileHandle: string) => {
      return `/api/folioMerge/${activityId}/pdf/${fileHandle}/pages`;
    },
    splitFolioPdfs: (activityId: number) => {
      return `/api/folioMerge/${activityId}/splitFolioPdfs`;
    }
  },
  folioCollection: {
    hotels: (myHotelsOnly?: boolean) =>
      `/api/folio-request/hotels${myHotelsOnly !== undefined ? `?myHotelsOnly=${myHotelsOnly}` : ''}`,
    hotelDetail: (hotelId: number) => `/api/folio-request/hotels/${hotelId}`,
    hotelHistory: (hotelId: number) => `/api/folio-request/hotels/${hotelId}/history`,
    activityDetail: (activityId: number) => `/api/folio-request/activities/${activityId}`,
    completeRequest: '/api/folio-request/complete',
    assignUser: '/api/folio-request/assignUser',
    emailPreview: '/api/folio-request/email/preview',
    completeEmailRequest: '/api/folio-request/email/complete'
  }
};
